export default {
  field: {
    label: 'Catégorie de taxe',
    placeholder: 'Aucune catégorie de taxe',
    unlinked_hint:
      'Sans catégorie fiscale, un produit utilise celle de sa catégorie de menu, ou le taux standard du restaurant.',
    default_hint: 'Sans catégorie, la catégorie de taxe par défaut du menu sera appliquée.',
  },
  empty: {
    hint: "Aucune catégorie de taxe pour l'instant — ajoutez-en une ci-dessous.",
    read_only_hint: "Aucune catégorie de taxe n'a encore été configurée.",
  },
  option: {
    varies_by_channel: '(varie selon le canal)',
  },
  load_error:
    "Impossible de charger les catégories de taxe — la liaison et la déliaison sont désactivées jusqu'à ce que cela charge.",
  create: {
    name_placeholder: 'Nom de la nouvelle catégorie',
    rate_placeholder: 'Taux %',
    button: 'Ajouter une catégorie de taxe',
  },
  toasts: {
    create_error: 'Impossible de créer la catégorie de taxe.',
  },
};
